<template>
  <div class="hello">
    <h1>Dagens ASCII</h1>
    <div v-for="letter in name.slice(0, day)">
      <h1>
        {{ letter }}
      </h1>
    </div>
    <div>
      <h1>
        {{ '[' + this.name[this.day] + '] = ' + this.name.charCodeAt(this.day)  }}
      </h1>
    </div>
    <div v-for="letter in name.slice(this.day+1)">
      <h1>
        {{ letter }}
      </h1>
    </div>
    <!-- <h1>{{ this.name.slice(0, this.day)+ this.name[this.day]  + this.name.slice(this.day+1) + ' = ' + this.name.charCodeAt(this.day) }}</h1> -->
  </div>
</template>

<script>
export default {
  mounted() {
    console.log(this.day);
    
  },
  name: 'HelloWorld',
  data () {
    return {
      day: new Date(Date.now()).getDay() - 1,
      name: 'Rickard'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
  margin: 5px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue